import type { Translate } from "@ui/providers/useTranslations";

import { replaceStringPlaceholder } from "../replaceStringPlaceholder/replaceStringPlaceholder";

export const getTimeDiff = (date: string) => Math.abs(new Date(date).getTime() - Date.now());

type ValidateBadgeDataProps = {
  __: Translate;
  newOfferDays?: number;
  timeFrom?: string;
  timeTo?: string;
  daysLabel?: string;
  oneDayLabel?: string;
};

type ValidateBadgeDataReturnType = {
  isNewBadgeVisible: boolean;
  isMoreThanOneDay: boolean;
  limitedTimeOfferLabel: string;
};

export const validateLimitedTimeBadgesData = ({
  __,
  newOfferDays,
  timeFrom,
  timeTo,
  daysLabel,
  oneDayLabel,
}: ValidateBadgeDataProps): ValidateBadgeDataReturnType => {
  let limitedTimeOfferLabel;
  const daysDiffInDays = timeFrom && getTimeDiff(timeFrom) / (1000 * 3600 * 24);
  const isNewBadgeVisible = !!(newOfferDays && daysDiffInDays && daysDiffInDays <= newOfferDays);
  const timeLeftInDays = timeTo ? Math.floor(getTimeDiff(timeTo) / (1000 * 3600 * 24)) : 0;
  const isMoreThanOneDay = timeLeftInDays > 1;

  if (daysLabel && oneDayLabel) {
    const limitedTimeOfferLabelVariant = isMoreThanOneDay ? daysLabel : oneDayLabel;
    limitedTimeOfferLabel = replaceStringPlaceholder(
      limitedTimeOfferLabelVariant,
      [
        {
          placeholder: "days",
          value: timeLeftInDays,
        },
      ],
      false
    );
  } else {
    limitedTimeOfferLabel = isMoreThanOneDay
      ? __("prizes.days.label", [timeLeftInDays])
      : __("prizes.one.day.label", [timeLeftInDays]);
  }

  return {
    isNewBadgeVisible,
    isMoreThanOneDay,
    limitedTimeOfferLabel,
  };
};
